import { useMutation } from "@tanstack/react-query"
import { assertWithErrorCode } from "@krakentech/error-intl"
import { ERROR_CODE } from "@/constants/errorCode"
import { OEBackend } from "@/graphql"
import { useGraphQLClient } from "@/lib/blueprint-auth/client"
import { logger } from "@/lib/logger"

const ExtractPDLFromInvoiceMutation = OEBackend.graphql(`
    mutation ExtractPdlFromInvoice($encodedPdf: String!) {
        extractPdlFromInvoice(encodedPdf: $encodedPdf) {
            pdl
        }
    }
`)

export function useExtractPDLFromInvoice() {
    const oeGraphQLClient = useGraphQLClient({ target: "oeBackend" })

    return useMutation({
        mutationKey: ["extractPDLFromInvoice"],
        mutationFn: async (encodedPdf: string) => {
            const data = await oeGraphQLClient.request(ExtractPDLFromInvoiceMutation, {
                encodedPdf,
            })

            try {
                assertWithErrorCode(data.extractPdlFromInvoice?.pdl, ERROR_CODE.UNKNOWN_ERROR)

                return data.extractPdlFromInvoice.pdl
            } catch {
                logger.error({
                    error: new Error("Failed to extract PDL from invoice"),
                    meta: {
                        feature: "invoiceUploadGetPRMId",
                        source: "useExtractInvoice",
                    },
                })

                return null
            }
        },
        onError: () => {
            logger.error({
                error: new Error("Failed to extract PDL from invoice"),
                meta: {
                    feature: "invoiceUploadGetPRMId",
                    source: "useExtractInvoice",
                },
            })
        },
    })
}
